import GoogleTrend from './component/GoogleTrend'
import NumberGoogleSearch from './component/NumberGoogleSearch'
const RespiratorySyndroms = () => {
  return (
    <>
      <div className='  p-0 w-100 justify-content-md-center container-fluid'>
        <div  className='mb-5'>
          <GoogleTrend />
        </div>
        <div  className='mb-5'>
          <NumberGoogleSearch />
        </div>
      </div>
    </>
  )
}
export {RespiratorySyndroms}
